import CartaId from '../../entities/CartaId';
import SubmitPortOpeningRequestRuleOnPrem from './SubmitPortOpeningRequestRuleOnPrem';

export default class SubmitPortOpeningRequestOnPrem {

	type!: string

	portOpeningRules!: SubmitPortOpeningRequestRuleOnPrem[];

	direction!: string;
	
	contactId!: string;
	
    businessJustification!: string;
	
    comments!: string;

	approverId!: string;
	
	onPremPortOpeningRequestId!: number;

	cartaId!: CartaId[];

    firewall!: string; //Firewall

	firewallEnvironment!: string;

	siteCoordination!: boolean;

	trackerID!: number;

	appEndorserId!: string;

    submitDate!: Date;

	hasRiskPorts!: boolean;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}